import { groupBy, map, partition } from "lodash";
import isNullish from "utils/isNullish";

const nonEmpty = (values) => (values.length > 0 ? values : null);

const shownWhenAny = (values) => (values.length > 0 ? values : undefined);

const isInCollection = (source) =>
  source.sourceKind === "COLLECTION" && Boolean(source.collectionLabel);

export const groundingFromSelection = (selection) => ({
  documentIds: nonEmpty(
    (selection?.documents ?? [])
      .map((document) => document.hash)
      .filter(Boolean)
  ),
  collectionIds: nonEmpty(
    (selection?.collections ?? [])
      .map((collection) => collection.collectionId)
      .filter((id) => !isNullish(id))
  ),
});

export const groundedSourcesOf = (sources) => {
  const named = (sources ?? []).filter((source) => Boolean(source.label));
  const [inCollections, documents] = partition(named, isInCollection);
  return {
    groundedDocuments: shownWhenAny(
      documents.map((source) => ({
        name: source.label,
        hash: source.sourceRef,
      }))
    ),
    groundedCollections: shownWhenAny(
      map(groupBy(inCollections, "collectionLabel"), (members, name) => ({
        name,
        files: map(members, "label"),
      }))
    ),
  };
};
